/*jslint browser: true*/ /*global jQuery,$*/

/*
 * No ready function needed because scripts are loaded at end of DOM before </body>
 */

// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

(function ($) {
    "use strict";

    /**
     * Bootstrap Tooltips
     *
     * *****************************************************************************************************************
     * http://getbootstrap.com/javascript/#tooltips
     **/

        // Default Initialization
    $('[data-toggle="tooltip"]').tooltip();

    /**
     * Select2
     *
     * *****************************************************************************************************************
     * https://github.com/select2/select2
     *
     * Activate on <select> by adding class "select2" (or "chosen-select" for backwards-compatibility).
     **/
    var mySelect2 = {
        /**
         * Skip usage of Select2 on mobile devices.
         * @return {boolean}
         */
        willInitialize: function () {
            return !(conditionizr.ios ||
                     (/Android/i.test(window.navigator.userAgent) && /Mobile/i.test(window.navigator.userAgent)));
        },


        /**
         * If Select2 is not supported and will not be initialized, we must mark the placeholder <option> as selected
         * and disabled while also setting the text with that which is in the data-placeholder attribute. Otherwise,
         * the <select> element will gain the "select2-enabled" class name .
         *
         * Placeholder options should always be first and have an empty value.
         */
        setup: function () {
            var $elements = $('.select2, .select2-deselect, .chosen-select, .chosen-select-deselect');
            if (!mySelect2.willInitialize()) {
                // Mobile view (without Select2).
                $elements.each(function () {
                    var $this = $(this),
                        $placeholder = $this.find('option').first().filter('[value=""]');

                    // Set the placeholder text.
                    $placeholder.text($this.data('placeholder'));

                    // Remove empty options.
                    $this.find('option')
                        .filter(function () {
                            return '' == $(this).text();
                        })
                        .remove();

                    if ($this.is('.select2') || $this.is('chosen-select')) {
                        // Disable the placeholder option when `select.select2`.
                        $placeholder.prop('disabled', true);
                    }

                    if (!$this.val()) {
                        // Select the placeholder option by default.
                        $placeholder.prop('selected', true);
                    }
                });
            } else {
                // Set up Select2 for use.
                $elements.addClass('select2-enabled');
            }
        },

        /**
         * Initializes select2 with desired settings.
         */
        initialize: function () {

            // Run Setup
            mySelect2.setup();

            var fuzzyMatcher = function (params, data) {
                // return all opts if search box is empty
                if(!params.term) {
                    return data;
                } else if(data) {
                    var term = params.term.toUpperCase();
                    var option = data.text.toUpperCase();
                    var j = -1; // remembers position of last found character

                    // consider each search character one at a time
                    for (var i = 0; i < term.length; i++) {
                        var l = term[i];
                        if (l == ' ') continue;     // ignore spaces

                        j = option.indexOf(l, j+1);     // search for character & update position
                        if (j == -1) return false;  // if it's not found, exclude this item
                    }
                    return data; // return option
                }
            };

            // Initialize
            $('.select2-enabled').each(function () {
                var $this = $(this);
                var options = {
                    allowClear: $this.hasClass('select2-deselect') || $this.hasClass('chosen-select-deselect'),
                    maximumSelectionLength: $this.data('select2-max-selected') || $this.data('chosen-max-selected') || 0,
                    minimumResultsForSearch: 5, // max amount of options before search field is provided
                    placeholder: $this.data('placeholder'),
                    width: '100%' // responsive layout support
                };
                if ($this.hasClass('select2-fuzzy-search') || $this.hasClass('chosen-fuzzy-search')) {
                    options.matcher = fuzzyMatcher;
                }
                $this.select2(options);
            });
        },

        /**
         * Function for other code when updating select2 when <select> options or disabled state changes
         * @param {string|jQuery} target
         */
        update: function (target) {
            var $target = $(target);
            $target
                .filter('.select2-enabled')
                .add($target.find('.select2-enabled'))
                .trigger('change.select2')
            ;
        }
    };

    // Start up Select2
    $.fn.select2.defaults.set('theme', 'bootstrap');
    mySelect2.initialize();

    // Initialize sbox collapse areas.
    $('.sbox-collapse-area').collapse({ toggle: false });

    /**
     * Form Helpers
     *
     * *****************************************************************************************************************
     * Various functions for manipulating fields and UI in forms.
     * Several utilize data-attributes for ease of implementation.
     *
     * *****************************************************************************************************************
     * IMPORTANT: These are user triggered actions. Initial states etc should be done in TWIG in the template.
     **/

    // Form Helpers Object Literal
    var myFh = {

        /**
         * Checkbox Disable Field
         *
         * Data attributes that cause a checkbox to disable a field when checked, enable when unchecked.
         *
         * @attribute data-fhcheck-disable defines the field that will be toggle between disabled states.
         */
        checkDisable: function () {
            // collect target from data-fhcheck-disable
            var $checkbox = $(this)
              , $target = $($checkbox.data('fhcheck-disable'));

            if ($checkbox.prop('disabled') || $checkbox.prop('readonly')) {
                // Do nothing if the checkbox is disabled or readonly.
                return;
            }

            // toggle disabled state of target field(s)
            $target.prop('disabled', $checkbox.is(':checked'));

            // Update the UI.
            myFh.refreshSelectsAndToggles($target);
        },

        /**
         * Checkbox Enable Field
         *
         * Data attributes that cause a checkbox to enable a field when checked, disable when unchecked.
         *
         * @attribute data-fhcheck-enable defines the field that will be toggle between disabled states.
         */
        checkEnable: function () {
            // collect target from data-fhcheck-enable
            var $checkbox = $(this)
              , $target = $($checkbox.data('fhcheck-enable'));

            if ($checkbox.prop('disabled') || $checkbox.prop('readonly')) {
                // Do nothing if the checkbox is disabled or readonly.
                return;
            }

            // toggle disabled state of target field(s)
            $target.prop('disabled', !$checkbox.is(':checked'));

            // Update the UI.
            myFh.refreshSelectsAndToggles($target);
        },

        /**
         * Checkbox Toggle Field Visibility
         *
         * Data attributes that cause a checkbox to toggle the "invisible" class on a field when (un)checked.
         *
         * @attribute data-fhcheck-toggle-visible defines the field that will be toggled between "invisible" states.
         */
        checkToggleVisibility: function () {
            // collect target from data-fhcheck-toggle-visible
            var $target = $($(this).data('fhcheck-toggle-visible'));

            if ($target.prop('disabled') || $target.prop('readonly')) {
                // Do nothing if the checkbox is disabled or readonly.
                return;
            }

            // toggle "invisible" class on target field(s)
            $target.toggleClass('invisible');
        },

        /**
         * Toggles the .hidden class on the target element(s) specified by the `dataAttr`.
         */
        checkToggleHidden: function (event) {
            var $element = $(this),
                isChecked = $element.is(':checked'),
                hide = event.data.hideWhenChecked == isChecked;
            if (!$element.prop('disabled') && !$element.prop('readonly')) {
                $($element.data(event.data.dataAttr)).toggleClass('hidden', hide);
            }
        },

        /**
         * Checkbox Check Toggles Collapse Open
         *
         * Data attribute targets a collapse and toggles it open if checkbox is checked, close if checkbox is unchecked.
         * @attribute data-fhchecked-toggle-collapse-open defines the collapse div that is toggled.
         */
        checkedToggleCollapseOpen : function () {
            myFh._checkboxToggleCollapse($(this), 'fhchecked-toggle-collapse-open', 'show', 'hide');
        },

        /**
         * Checkbox Check Toggles Collapse Close
         *
         * Data attribute targets a collapse and toggles it close if checkbox is checked, open if checkbox is unchecked.
         * @attribute data-fhchecked-toggle-collapse-close defines the collapse div that is toggled.
         */
        checkedToggleCollapseClose : function () {
            myFh._checkboxToggleCollapse($(this), 'fhchecked-toggle-collapse-close', 'hide', 'show');
        },

        /**
         * Handles the opening/closing of a collapsible target based on the state of the checkbox.
         * @param                 $checkbox      The checkbox element which determines the state of the collapsible.
         * @param {string}        targetData     The data tag to read the target collapsible from.
         * @param {string|Object} checkedParam   The parameter to be passed to the `collapse()` call when checked.
         * @param {string|Object} uncheckedParam The parameter to be passed to the `collapse()` call when unchecked.
         * @private
         */
        _checkboxToggleCollapse: function ($checkbox, targetData, checkedParam, uncheckedParam) {

            if ($checkbox.prop('disabled') || $checkbox.prop('readonly')) {
                // Do nothing if the checkbox is disabled or read-only.
                return;
            }

            // Fire collapse on final event leaving time for previous animation to complete
            //
            // Based on https://css-tricks.com/snippets/jquery/done-resizing-event/
            setTimeout(
                function() {
                    $($checkbox.data(targetData)).collapse($checkbox.prop('checked') ? checkedParam : uncheckedParam);
                },
                225
            );
        },

        /**
         * Checkbox Checked Un-Collapse
         *
         * Data attribute targets a collapse and un-collapses it on check
         * @attribute data-fhchecked-uncollapse defines the collapse dev that should be un-collapsed.
         */
        checkedUnCollapse: function () {
            var $this = $(this);
            if ($this.is(':checked') && !$this.prop('disabled') && !$this.prop('readonly')) {
                // Un-collapse using Bootstrap method http://getbootstrap.com/javascript/#collapse-methods
                // collect target from data attribute
                $($this.data('fhchecked-uncollapse')).collapse('show');
            }
        },

        /**
         * Checkbox Text Change
         *
         * Data attributes that cause a checkbox to change out text or HTML content in a targeted element.
         *
         * @attribute data-fhcheck-content-target defines the HTML element where you want to change the content within.
         * @attribute data-fhcheck-change-content-checked defines the text/html content when the checkbox is checked.
         * @attribute data-fhcheck-change-content-unchecked defines the text/html content when the checkbox is checked.
         */
        checkChangeContent: function () {
            var $this = $(this)
              , target = $this.data('fhcheck-change-content-target') // collect target for change;
              , content // collect based on checkbox state text
            ;

            if ($this.prop('disabled') || $this.prop('readonly')) {
                // Do nothing if the checkbox is disabled or read-only.
                return;
            }

            if ($this.prop('checked')) {
                content = $this.data('fhcheck-change-content-checked');
            } else {
                content = $this.data('fhcheck-change-content-unchecked');
            }
            // change target content
            $(target).html(content);
        },

        /**
         * Select Option Text Change
         *
         * Data attributes that causes a option on a select to change out text or HTML content in a targeted element.
         *
         * @attribute data-fhselect-change-content-target defines the target element and goes on the <select>.
         * @attribute data-fhselect-change-content defines the target content when selected and goes on the <option>.
         */
        selectChangeContent: function () {
            var $this = $(this)
              , target = $this.data('fhselect-change-content-target') // collect target
              , content = $this.find("option:selected").data('fhselect-change-content') // collect content
            ;

            if (!$this.prop('disabled') && !$this.prop('readonly')) {
                // change target content
                $(target).html(content);
            }
        },

        /**
         * Disable/enable target element(s) when placeholder option is selected/unselected.
         * Reads target selector from `data-fhselect-placeholder-disables-target` on `select` elements.
         * @private
         */
        _initSelectPlaceholderDisables: function () {
            var $this = $(this);
            // Set up the data attributes to work with `selectEnableDisable()`.
            $this.attr('data-fhselect-enable-disable-target', $this.data('fhselect-placeholder-disables-target'))
                .find('.placeholder').attr('data-fhselect-disable', '').end()
                .find('option').not('.placeholder').attr('data-fhselect-enable', '');
        },

        /**
         * Select Option Enable/Disable Field
         *
         * Data attributes target and enable/disable a field depending on the select option selected
         *
         * @attribute data-fhselect-enable-disable-target defines the target and goes on the <select>
         * @attribute data-fhselect-enable-target on an <option> makes that option enable the target field
         * @attribute data-fhselect-disable-target on an <option> makes that option disable the target field
         */
        selectEnableDisable: function () {
            // collect target
            var $this = $(this)
              , $target = $($this.data('fhselect-enable-disable-target'))
              , $selectedOption = $this.find("option:selected")
            ;

            if ($this.prop('disabled') || $this.prop('readonly')) {
                // Do nothing if the select is disabled or read-only.
                return;
            }

            // enable/disable target
            $target.prop('disabled', !$selectedOption.is('[data-fhselect-enable]'));

            // Update the UI.
            myFh.refreshSelectsAndToggles($target);
        },

        /**
         * Enable/disable target element(s) when option is selected/unselected.
         * Reads target selector from `data-fhoption-enable-target` on `option` elements.
         * @private
         */
        _optionEnable: function () {
            var $select = $(this);
            var $selectedTarget;
            var $otherTargets = $();

            if ($select.prop('disabled') || $select.prop('readonly')) {
                // Do nothing if the select is disabled or read-only.
                return;
            }

            // Grab target for selected option.
            $selectedTarget = $($select.find('option').filter(':selected').data('fhoption-enable-target'));

            // Grab targets for other sibling unselected options.
            $select.find('option').not(':selected').each(function () {
                $otherTargets = $otherTargets.add($(this).data('fhoption-enable-target'));
            });

            // Disable targets for other siblings
            // as long as they don't match any of the targets for the current selection.
            $otherTargets = $otherTargets.not($selectedTarget)
                .prop('disabled', true);

            // Enable the target for the current selection.
            $selectedTarget.prop('disabled', false);

            // Refresh the UI.
            myFh.refreshSelectsAndToggles($selectedTarget.add($otherTargets));
        },

        /**
         * Silently updates UI elements for select2 and bootstrap toggle elements.
         * @param {string|jQuery} target Target and/or parent element containing descendants to update.
         */
        refreshSelectsAndToggles: function (target) {
            var $target = $(target);
            mySelect2.update($target);
            $target
                .filter('[data-toggle="toggle"]')
                .add($target.find('[data-toggle="toggle"]'))
                .bootstrapToggle('update', true)
            ;
        },

        /**
         * Slide up/down target element(s) when option is selected/unselected.
         * Reads target selector from `data-fhoption-slide-target` on `option` elements.
         * @private
         */
        _optionSlide: function () {
            var $select = $(this);
            var $selectedTarget;
            var $otherTargets = $();

            if ($select.prop('disabled') || $select.prop('readonly')) {
                // Do nothing if the select is disabled or read-only.
                return;
            }

            // Grab target for selected option.
            $selectedTarget = $($select.find('option').filter(':selected').data('fhoption-slide-target'));
            if ($selectedTarget.hasClass('hide')) {
                // Remove .hide class to prevent any display oddities.
                $selectedTarget.hide().removeClass('hide');
            }

            // Grab targets for other sibling unselected options.
            $select.find('option').not(':selected').each(function () {
                $otherTargets = $otherTargets.add($(this).data('fhoption-slide-target'));
            });

            // Slide up (hide) targets for other siblings
            // as long as they don't match any of the targets for the current selection.
            $otherTargets.not($selectedTarget).slideUp();

            // Simultaneously slide down (show) targets for current selection.
            $selectedTarget.slideDown();
        },

        /**
         * Show/hide target element(s) when option is selected/unselected.
         * Reads target selector from `data-fhoption-show-target` on `option` elements.
         * @private
         */
        _optionShow: function () {
            var $select = $(this);
            var $selectedTarget;
            var $otherTargets = $();

            if ($select.prop('disabled') || $select.prop('readonly')) {
                // Do nothing if the select is disabled or read-only.
                return;
            }

            // Grab target for selected option.
            $selectedTarget = $($select.find('option').filter(':selected').data('fhoption-show-target'));
            if ($selectedTarget.hasClass('hide')) {
                // Remove .hide class to prevent any display oddities.
                $selectedTarget.hide().removeClass('hide');
            }

            // Grab targets for other sibling unselected options.
            $select.find('option').not(':selected').each(function () {
                $otherTargets = $otherTargets.add($(this).data('fhoption-show-target'));
            });

            // Hide targets for other siblings as long as they don't match any of the targets for the current selection.
            $otherTargets.not($selectedTarget).hide();

            // Simultaneously show targets for current selection.
            $selectedTarget.show();
        },

        /**
         * Clear Field Target
         *
         * Data attribute that makes a button clear a targeted field
         *
         * @attribute data-fhclear defines the targeted field to clear and goes on the UI element.
         */
        clearField: function () {
            // Collect target from data-fhclear attribute. Can be more than one.
            var $target = $($(this).data('fhclear'));

            // Loop through the targets and find what they represent.
            $target.each(function () {
                var $elm = $(this);

                // if target input(s) has a pickadate-date class, it is a pick-a-date object. Use the API to clear it.
                if ($elm.hasClass('pickadate-date')) {
                    $elm.pickadate('clear').trigger('change');
                } else {

                    // Not a pick-a-date object, then, clear it normally.
                    if ($elm.prop('checked')) {
                        // Only clear the checked property if it exists on the input.
                        $elm.prop('checked', false);
                    } else {
                        $elm.val('').trigger('change');
                    }

                    mySelect2.update($target);
                }
            });

            // clear focus when complete
            $(this).trigger('blur');
        },

        /**
         * Form Reset
         *
         * Resets the form that (this) exists in.
         *
         * We do this because some jquery actions, such as disabling buttons, block the native <button type="reset">
         * functionality. Select2 selects also need to be updated.
         */
        formReset: function () {
            // find parent form and reset
            var $form = $(this).closest('form');
            $form.get(0).reset();

            // Refresh the UI.
            myFh.refreshSelectsAndToggles($form);

            // un-focus reset button
            $(this).trigger('blur');
        },

        /**
         * Pluralize
         *
         * Change a targeted element's text based number field value
         *
         * @attribute data-fhplural sets the target element and goes on the number field
         * @attribute data-pural sets the pural text or html to be applied and goes on the targeted element
         * @attribute data-singular sets the singular text or html to be applied and goes on the targeted element
         *
         * While this accepts HTML remember that <option>s can't have children.
         */
        pluralize: function () {

            var $this = $(this)
              , number = $this.val() // get number
              , content // change between plural and singular
            ;

            if ($this.prop('disabled') || $this.prop('readonly')) {
                // Do nothing if the element is disabled or read-only.
                return;
            }

            $($this.data('fhplural')).each(function () {
                var $this = $(this);

                if (number == 1) {
                    content = $(this).data('singular');
                } else {
                    content = $(this).data('plural');
                }
                $this.html(content);
                // if target is an option of a Select2 select, update the Select2 select
                mySelect2.update($this.parents('.select2-enabled'));
            });
        },

        /**
         * Copies the value of the triggering element to the value of the target element(s) specified by
         * `data-fhcopy-value-to`.
         */
        copyValueTo: function () {
            var $input = $(this);
            var $target = $($input.data('fhcopy-value-to'));
            if (!$input.prop('disabled') && !$input.prop('readonly')) {
                $target.val($input.val());
                mySelect2.update($target);
            }
        },

        /**
         * Copies the checked state of the triggering element to the state of the target element(s) specified by
         * `data-fhcopy-checked-to`.
         */
        copyCheckedTo: function () {
            var $input = $(this);
            if (!$input.prop('disabled') && !$input.prop('readonly')) {
                $($input.data('fhcopy-checked-to')).prop('checked', $input.prop('checked')).trigger('change');
            }
        },

        /**
         * Copies the value of the triggering element OR from the source specified by `data-fhcheck-copy-value-from`
         * to the value of the target element(s) specified by `data-fhcheck-copy-value-to`.
         */
        checkedCopyValueTo: function () {
            var $toggle = $(this),
                fromData = $toggle.data('fhcheck-copy-value-from'),
                $source = fromData ? $(fromData) : $toggle;

            if ($toggle.prop('checked') && !$toggle.prop('disabled') && !$toggle.prop('readonly')) {
                $($toggle.data('fhcheck-copy-value-to')).val($source.val());
            }
        },

        /**
         * Checkbox Toggles Password Visibility
         */
        passwordMaskCheckbox: function() {

            // Determine input type from checkbox state and password input target
            var inputType = (this.checked) ? 'text' : 'password',
                $input    = $($(this).attr('data-passwordMaskCheckbox'));

            // Apply input type to input
            $input.attr('type', inputType);
        },

        /**
         * Password Field Masking
         *
         * Checkbox toggles password masking.
         * If a password manager like LastPass changes input field type checkbox state is updated.
         */
        pwdMask: {

            // When checkbox is checked/unchecked
            checkboxChange: function() {

                // When checkbox is changed check checked state and update input type accordingly
                var inputType = (this.checked) ? 'text' : 'password',
                    $input    = $($(this).attr('data-pwdMaskInput'));

                // Apply input type to input
                $input.attr('type', inputType);
            },

            // When input is changed check type and update checkbox accordingly
            inputChange: function() {

                // Determine checkbox state from input type
                var check = (this.type !== 'password'),
                    $checkbox = $($(this).attr('data-pwdMaskCheckbox'));

                // Update checkbox checked state
                $checkbox.prop('checked', check);
            }
        },

            /**
             * Disables non-select elements and individual select option elements when values conflict between elements
             * matching the selector specified by `data-fh-exclusive-to`.
             */
            _exclusiveTo: function () {
                var $el = $(this);
                var dataExclusiveTo = 'fh-exclusive-to';
                var dataConflictsWith = 'exclusive-conflicts-with';
                var id = $el.attr('id');
                var val = $el.val();
                var $otherParentEls = $($el.data(dataExclusiveTo)).not($el);
                var $otherEls = $otherParentEls
                    .not('select') // Remove all select elements.
                    .add($otherParentEls.find('option').not('.placeholder')); // Add non-placeholder options from select elements.

                $otherEls.each(function () {
                    // Inspect each non-select and option element for conflicts.
                    var $this = $(this);
                    var conflictsWith = $this.data(dataConflictsWith) || [];
                    var previousConflictIndex = $.inArray(id, conflictsWith);
                    var wasAConflict = -1 !== previousConflictIndex;
                    var nowIsConflict = (val + '') === ($this.val() + '');

                    if (wasAConflict && !nowIsConflict) {
                        // Remove the conflict with the previous value.
                        conflictsWith.splice(previousConflictIndex, 1);
                    } else if (!wasAConflict && nowIsConflict) {
                        // Add the new conflict and disable element.
                        conflictsWith.push(id);
                        $this.prop('disabled', true);
                    }

                    if (!conflictsWith.length) {
                        // Enable element since no conflicts remain.
                        $this.prop('disabled', false);
                    }

                    // Update list of conflicts stored in data.
                    $this.data(dataConflictsWith, conflictsWith);
                });

                // Refresh the UI.
                myFh.refreshSelectsAndToggles($otherParentEls);
            },

        /**
         * Initializations
         *
         * Binds trigger events
         */
        init: function () {
            // Toggle disabled state of field(s) on checkbox check or uncheck
            $('[data-fhcheck-disable]').on('change', myFh.checkDisable);
            $('[data-fhcheck-enable]').on('change', myFh.checkEnable);

            // Toggle visibility of field(s) on checkbox check or uncheck
            $('[data-fhcheck-toggle-visible]').on('change', myFh.checkToggleVisibility);

            // Toggle "hidden" class of field(s) on checkbox check or uncheck.
            $('[data-fhcheck-hide]').on('change', { dataAttr: 'fhcheck-hide', hideWhenChecked: true }, myFh.checkToggleHidden);
            $('[data-fhcheck-show]').on('change', { dataAttr: 'fhcheck-show', hideWhenChecked: false }, myFh.checkToggleHidden);

            // Toggle collapse open on checkbox check
            $('[data-fhchecked-toggle-collapse-open]').on('change', myFh.checkedToggleCollapseOpen);

            // Toggle collapse closed on checkbox check
            $('[data-fhchecked-toggle-collapse-close]').on('change', myFh.checkedToggleCollapseClose);

            // Un-collapse on checkbox check
            $('[data-fhchecked-uncollapse]').on('change', myFh.checkedUnCollapse);

            // Change targeted HTML content on checkbox click
            $('[data-fhcheck-change-content-target]').on('change', myFh.checkChangeContent);

            // Change targeted HTML content on select option selection
            $('[data-fhselect-change-content-target]').on('change', myFh.selectChangeContent);

            // Disable/enable target field based on whether select placeholder option is selected
            $('[data-fhselect-placeholder-disables-target]').each(myFh._initSelectPlaceholderDisables);

            // Enable or Disable target field if select option is selected
            $('[data-fhselect-enable-disable-target]').on('change', myFh.selectEnableDisable);

            // Enables target(s) depending on selected option.
            $('option[data-fhoption-enable-target]').parents('select').on('change', myFh._optionEnable);

            // Slide target(s) up or down depending on selected option.
            $('option[data-fhoption-slide-target]').parents('select').on('change', myFh._optionSlide);

            // Show or hide depending on selected option.
            $('option[data-fhoption-show-target]').parents('select').on('change', myFh._optionShow);

            // Clear targeted field on click
            $('[data-fhclear]').on('click', myFh.clearField);

            // Reset parent form on reset button click
            //
            // Simply use <button type="reset"> for the cancel/reset button with your forms
            $('button[type="reset"]').on('click', myFh.formReset);

            // Toggle targeted text/html between plural and singular based on number value
            $('[data-fhplural]').on('change', myFh.pluralize);

            // Copies the value of the input to the value of the target.
            $('[data-fhcopy-value-to]').on('change keyup', myFh.copyValueTo);

            // Copies the checked state of the input to the value of the target.
            $('[data-fhcopy-checked-to]').on('change', myFh.copyCheckedTo);

            // Copies the value of the input or input source to the value of the target when checked.
            $('[data-fhcheck-copy-value-to]').on('change', myFh.checkedCopyValueTo);

            // Watch password masking checkbox for change
            $('[data-pwdMaskInput]').on('change', myFh.pwdMask.checkboxChange);

            // Watch password field for type change to update checkbox
            $('[data-pwdMaskCheckbox]').on('change', myFh.pwdMask.inputChange);

            // Ensures values are exclusive between elements matching selector.
            $('[data-fh-exclusive-to]')
                .each(myFh._exclusiveTo) // Set initial states.
                .on('change', myFh._exclusiveTo) // Set change listener.
            ;
        }
    };

    // Initialize Form Helpers
    myFh.init();


    /**
     * sBox Toggle List Labels
     *
     * *****************************************************************************************************************
     * When using a sBox toggle list this allows the label of the toggle to toggle the toggle.
     *
     **/

    var sboxToggleList = {

        init: function () {
            // bind trigger and toggle the toggle when it's label is clicked
            $('.sbox-toggle-list').find('.control-label').on("click", sboxToggleList.toggle);
        },

        toggle: function () {
            // get toggle input
            var $input = $('#' + $(this).attr('for'));
            if (!$input.prop('disabled') && !$input.prop('readonly')) {
                // toggle toggle checkbox if not disabled or read-only
                $input.prop('checked', !$input.prop('checked'));
            }
        }
    };

    // Initialize Toggle Label Toggling
    sboxToggleList.init();


    /**
     * sBox Unhide Invalid Child Inputs
     *
     * *****************************************************************************************************************
     * When using a sBox wrapper around form elements, this helper, upon form submission, will determine whether the
     * collapsed sBox contains invalid inputs and expand itself.
     *
     **/

    var sboxUnhideInvalidInput = {

        init: function () {
            // Since the submit event on the form is blocked by failed HTML5 validation,
            // grab a list of submit triggers belonging to forms containing inputs within sbox collapsibles.
            var $submits = $('form').has('.sbox-collapse-area :input').find(':submit');

            // Bind the handler to the click event on the submit trigger(s).
            $submits.on('click', this.unhideInvalidInput);
        },

        unhideInvalidInput: function (event) {
            // Determine the parent form attempting to be submitted.
            var $form = $(event.target).parents('form');

            // Un-collapse any collapsed sboxes containing invalid input fields.
            $('.sbox-collapse', $form)
                .has('.sbox-collapse-area:not(.in) :invalid')
                .children('.sbox-collapse-head')
                .trigger('click');
        }
    };

    // Initialize Invalid Input Unhiding
    sboxUnhideInvalidInput.init();


    /**
     * Pickadate Date Picker
     *
     * *****************************************************************************************************************
     * http://amsul.ca/pickadate.js/date/
     *
     * Settings and initialization via data attributes.
     * To use add class "pickadate-date" to an <input type="text">
     *
     * @attribute data-pickadate-min sets min value for pickadate (http://amsul.ca/pickadate.js/date/#limits)
     * @attribute data-pickadate-max sets max value for pickadate (http://amsul.ca/pickadate.js/date/#limits)
     * @attribute data-pickadate-small changes the date display output to a smaller format
     * @attribute data-pickadate-reports changes the date display output to a format used for report date range UI
     **/

    var datePicker = {

        init: function () {

            // Picker Date Formats
            // http://amsul.ca/pickadate.js/date/#formats
            datePicker.format = {
                large: 'dddd, mmmm d, yyyy',
                small: 'mm/dd/yy',
                reports: 'mmm dd, yyyy'
            };

            $('.pickadate-date').each(datePicker.run);
        },

        run: function () {

            var $datePicker = $(this);

            // get min/max limits if any
            var min    = $datePicker.data('pickadate-min');
            var max    = $datePicker.data('pickadate-max');
            var format = datePicker.format.large;

            // apply smaller display format if data-pickadate-small is applied
            if ($datePicker.is('[data-pickadate-small]')) {
                format = datePicker.format.small;
            } else if ($datePicker.is('[data-pickadate-reports]')) {
                format = datePicker.format.reports;
            }

            // Convert date formatted min/max strings to Date objects.
            if (typeof min == "string") {
                min = new Date(min);
            }
            if (typeof max == "string") {
                max = new Date(max);
            }

            // initialize datepicker
            $datePicker.pickadate({
                                      // no buttons
                                      today: '',
                                      clear: '',
                                      close: '',
                                      formatSubmit: 'mm/dd/yyyy',
                                      hiddenName: true,
                                      // format and limits from data attributes
                                      format: format,
                                      min: min,
                                      max: max,
                                      // Reset the month view to the current selection, if not the current month, each time the picker is opened.
                                      onOpen: function() {
                                          this.set('view', this.get('select') || new Date());
                                      }
                                  });
        }
    };

    // Initialize Date Picker
    datePicker.init();


    /**
     * ClockPicker Time Picker
     *
     * *****************************************************************************************************************
     * http://weareoutman.github.io/clockpicker/
     *
     * Settings and initialization via data attributes.
     * To use, add class "clockpicker" to an <input type="text">
     *
     * @attribute data-default    Default time value, 'now' or '13:14' e.g. (default: '').
     * @attribute data-placement  Picker popover placement (default: bottom).
     * @attribute data-align      Picker popover arrow align (default: left).
     * @attribute data-donetext   Done button text (default: Done).
     * @attribute data-autoclose  Auto close when minute is selected (default: false).
     * @attribute data-twelvehour Whether to operate in twelve hour mode with AM/PM. (default: true).
     **/

    var clockPicker = {

        init: function () {
            $('.clockpicker').each(clockPicker.run);
        },

        // Initialize the individual clockpicker inputs.
        run: function () {
            var $this = $(this);
            $this.clockpicker({
                                  donetext: $this.data('donetext') || 'Done',
                                  twelvehour: $this.data('twelvehour') || true
                              });
        }
    };

    // Initialize Clock Picker
    clockPicker.init();


    /**
     * Main Menu Toggle
     *
     * *****************************************************************************************************************
     * Toggles CSS classes used to open and close the main menu.
     *
     **/

    var mainMenuToggle = {

        init: function () {
            // bind and trigger on menu button click
            $('#btn-sidebar-toggle').on('click', mainMenuToggle.toggle);

            // keep sidebar open on page reload/route cgange, if persisted todo so
            const isPinned = JSON.parse(localStorage.getItem('sidebarPinned'));
            if (isPinned) {
                $('#btn-sidebar-toggle').add($('.container-sidebar')).addClass('menu-toggle');
            }
        },

        toggle: function (e) {
            var $btn = $(this)
              , isMenuToggle = $btn.hasClass('menu-toggle')
            ;
            // toggle classes on toggle and menu container
            $btn.add($('.container-sidebar'))
                .toggleClass('menu-toggle', !isMenuToggle)
            ;
            
            localStorage.setItem('sidebarPinned', JSON.stringify(!isMenuToggle)); // persist opened sidebar option

            e.preventDefault();
        }
    };

    // Initialize Main Menu Toggle
    mainMenuToggle.init();


    /**
     * Truncate long text in the display and create a tooltip to display the full length of the text.
     *
     * *****************************************************************************************************************
     * Initializes via data attribute.
     * To use, add data-se-truncate="(max length)" to a <td>, ie <td data-se-truncate="20">
     *
     * @attribute data-placement Tooltip placement (default: top).
     **/

    var truncate = {

        init: function () {
            $('td[data-se-truncate]').each(truncate.run);
        },

        // Perform the truncation of the individual table cells.
        run: function () {
            var $this = $(this),
                text  = $this.text(),
                max   = $this.data('se-truncate');

            // If the text length does not exceed the max, just bail.
            if (text.length <= max) {
                return;
            }

            // Truncate the displayed text and initialize a bootstrap tooltip for displaying the full text.
            $this.text(text.substr(0, max) + '…')
                .tooltip({
                             container: 'body',
                             placement: $this.data('placement'),
                             title: text
                         });
        }
    };

    // Initialize Main Menu Toggle
    truncate.init();

    /**
     * Set a form to only be able to be submitted one time. This is useful for preventing duplicated entries. This will
     * disable the submit button after the first time the form is submitted.
     *
     * *****************************************************************************************************************
     * Initializes via data attribute.
     * To use, add data-submit-once to the form that you would like to only submit one time.
     **/

    var submitOnce = {
        init: function () {
            $('form[data-submit-once]').find(':submit').one('click.submitOnce', submitOnce.run);
        },
        run: function (event) {
            var $button = $(event.target),
                value = $button.val();

            if ($button.is('button') && '' !== value) {
                // Duplicate the value of the button to a hidden field so it still is submitted.
                $('<input type="hidden" name="' + $button.attr('name') + '" value="' + value + '">')
                    .insertAfter($button);
            }

            // Disable the button to prevent duplicate submissions.
            var $formElement = $button.parents('form');
            if ($formElement[0].checkValidity()) {
                $button.prop("disabled", true);
                $formElement.trigger('submit');
            } else {
                // Requeue event.
                $button.one('click.submitOnce', submitOnce.run);
            }
        }
    };

    // Initialize submit once.
    submitOnce.init();

    /**
     * Standardized AJAX handling.
     *
     * To utilize, add the `ajaxify` class to any link or button and the following attributes will be read:
     *
     * - href: endpoint URL
     * - data-ajaxify-data: data to include in request
     * - data-ajaxify-method: request method (GET, POST, PUT, DELETE, etc). GET by default.
     *
     * Optionally include child elements matching the following classes to represent each state of the request:
     * - ajaxify-ready: Normal, ready state. Once request completes, return to this state after 5 seconds.
     * - ajaxify-sending: Request is being sent.
     * - ajaxify-success: Request returned success. Will be displayed for 5 seconds upon success.
     * - ajaxify-fail: Request returned failure. Will be displayed for 5 seconds upon failure.
     */
    var ajaxify = {

        $document: $(document),
        clickEvent: 'click.ajaxify',

        statuses: {
            ready: '.ajaxify-ready',
            sending: '.ajaxify-sending',
            success: '.ajaxify-success',
            fail: '.ajaxify-fail'
        },

        /**
         * Initializes AJAX-ify handling.
         */
        init: function () {
            ajaxify.$document.on(ajaxify.clickEvent, '.ajaxify:not(.ajaxifying)', ajaxify._send);
        },

        /**
         * Perform the AJAX request using the attributes of the clicked element.
         * @param {Event} e Event triggered by click.
         * @private
         */
        _send: function (e) {
            var $el = $(this)
              , resetStatus = function () {
                    setTimeout(function () {
                        ajaxify._setStatus($el, ajaxify.statuses.ready);
                        $el.removeClass('ajaxifying');
                    }, 5000);
                };
            e.preventDefault();

            // Prevent duplicate requests.
            $el.addClass('ajaxifying');

            // Switch to sending status.
            ajaxify._setStatus($el, ajaxify.statuses.sending);

            // Setup and perform the request.
            $.ajax({
                url: $el.attr('href'),
                data: $el.data('ajaxify-data'),
                method: $el.data('ajaxify-method') || 'GET'
            })
            .done(function (data) {
                /** @var {{ success: {boolean}, messages: {String[][]} }} data */
                if (!data.success) {
                    $.map(data.messages, function (group) {
                        $.map(group, function (message) {
                            console.log(message);
                        });
                    });
                }

                ajaxify._setStatus($el, data.success ? ajaxify.statuses.success : ajaxify.statuses.fail);
                resetStatus();

                $el.trigger('ajaxify.done', data);
            })
            .fail(function (jqXHR, status, error) {
                console.log(error);
                ajaxify._setStatus($el, ajaxify.statuses.fail);
                resetStatus();

                $el.trigger('ajaxify.fail', error);
            })
            ;
        },

        /**
         * Switches the state of the given element to the new status.
         * @param $el Element on which state will switch.
         * @param {string} newStatus Class name of new state to display.
         * @private
         */
        _setStatus: function ($el, newStatus) {
            var otherStatuses = []
              , $otherStatusEls
              , $newStatusEl = $el.find(newStatus)
            ;
            $.map(ajaxify.statuses, function (status) {
                if (status != newStatus) {
                    otherStatuses.push(status);
                }
            });

            // Only hide other statuses and show new status if both exist.
            $otherStatusEls = $el.find(otherStatuses.join(', '));
            if ($otherStatusEls.length && $newStatusEl.length) {
                $otherStatusEls.hide();
                $newStatusEl.show();
            }
        }
    };

    // Initialize ajaxify.
    ajaxify.init();
})(jQuery);


/* functions that need to called from separate files so be sure to use a UNIQUE variable ("sonny" prefix) for encapsulation */


/**
 * Sonny JS Alerts
 *
 * *****************************************************************************************************************
 * A function for generating js triggered alerts in the same manner of as the TWIG component.
 *
 * Use with one of the 4 allowable types based on Bootstrap http://getbootstrap.com/components/#alerts
 * Single message example: sonnyAlert.success('My Success Message');
 * List of messages example: sonnyAlert.danger(['My Error Message 1', 'My Error Message B']);
 *
 * @param string or array of strings msg Single or multiple alert messages. Can contain HTML.
 * @param string target The CSS class where the alert will be placed into.
 *                      If none given .alerts-js is used as default.
 * @param boolean dismissible If the alert is dismissible or not http://getbootstrap.com/components/#alerts-dismissible
 **/

var sonnyAlert = {

    danger: function (msg, target, dismissible) {
        sonnyAlert.build('danger', 'exclamation-sign', 'Error', msg, target, dismissible);
    },

    success: function (msg, target, dismissible) {
        sonnyAlert.build('success', 'ok-sign', 'Success', msg, target, dismissible);
    },

    info: function (msg, target, dismissible) {
        sonnyAlert.build('info', 'info-sign', 'Info', msg, target, dismissible);
    },

    warning: function (msg, target, dismissible) {
        sonnyAlert.build('warning', 'alert', 'Warning', msg, target, dismissible);
    },

    build: function (type, icon, label, msg, target, dismissible) {

        // default target if none given
        if (!target) {
            target = '.alerts-js';
        }

        // build start of alert container
        var alert = '<div class="alert alert-' + type + ' with-glyph" role="alert">';
        if (dismissible) {
            alert += '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>';
        }
        alert += '<span class="glyphicon glyphicon-' + icon + '" aria-hidden="true"></span>';
        alert += '<span class="sr-only">' + label + ': </span>';

        // build messages
        var content = '';
        // noinspection NodeModulesDependencies
        if (($.isArray(msg)) && (msg.length > 1)) {
            // if multiple errors build as list
            content += '<ul>';
            $.each(msg, function (index, msg) {
                content += '<li>' + msg + '</li>';
            });
            content += '</ul>';
        } else {
            content = '<p>' + msg + '</p>';
        }

        // add messages and close alert markup
        alert += content + '</div><!-- /alert-' + type + ' -->';

        // display alert
        sonnyAlert.display(alert, target);
    },

    display: function (alert, target) {
        $(target).append(alert);
    }
};

/**
 * Sonny Colors
 *
 * *****************************************************************************************************************
 * Website LESS CSS colors replicated into JS variables for use with scripts like chartsjs. This should always be in
 * sync with color variables of the same name (camelCase in js instead of dashes in LESS) in variables-forked.less.
 *
 * RGBa Function:
 * @param number opacity Number from 0 to 1.0 to apply as alpha (opacity) in RGBa output with 1.0 being default.
 *
 **/

var sonnyColor = {

    // colors matching LESS variables from variables-forked.less
    greenDark: {
        hex: '#070D0D',
        rgba: function (opacity) {
            return sonnyColor.buildRGBa('7, 13, 13', opacity);
        }
    },
    grayDarkest: {
        hex: '#252525',
        rgba: function (opacity) {
            return sonnyColor.buildRGBa('37, 37, 37', opacity);
        }
    },
    grayDarker2: {
        hex: '#4d4d4d',
        rgba: function (opacity) {
            return sonnyColor.buildRGBa('77, 77, 77', opacity);
        }
    },
    grayDarker: {
        hex: '#343434',
        rgba: function (opacity) {
            return sonnyColor.buildRGBa('52, 52, 52', opacity);
        }
    },
    grayDark: {
        hex: '#999999',
        rgba: function (opacity) {
            return sonnyColor.buildRGBa('153, 153, 153', opacity);
        }
    },
    gray: {
        hex: '#cccccc',
        rgba: function (opacity) {
            return sonnyColor.buildRGBa('204, 204, 204', opacity);
        }
    },
    grayLight: {
        hex: '#e6e6e6',
        rgba: function (opacity) {
            return sonnyColor.buildRGBa('230, 230, 230', opacity);
        }
    },
    grayLighter: {
        hex: '#f7f7f7',
        rgba: function (opacity) {
            return sonnyColor.buildRGBa('247, 247, 247', opacity);
        }
    },
    brandPrimary: {
        hex: '#004b8d',
        rgba: function (opacity) {
            return sonnyColor.buildRGBa('0, 75, 141', opacity);
        }
    },
    brandSuccess: {
        hex: '#00cb69',
        rgba: function (opacity) {
            return sonnyColor.buildRGBa('0, 203, 105', opacity);
        }
    },
    brandInfo: {
        hex: '#0093d0',
        rgba: function (opacity) {
            return sonnyColor.buildRGBa('0, 147, 208', opacity);
        }
    },
    brandWarning: {
        hex: '#ffdd00',
        rgba: function (opacity) {
            return sonnyColor.buildRGBa('255, 221, 0', opacity);
        }
    },
    brandDanger: {
        hex: '#ee4f69',
        rgba: function (opacity) {
            return sonnyColor.buildRGBa('238, 79, 105', opacity);
        }
    },

    // Create RGBa from given RGB and opacity
    buildRGBa: function(rgb, opacity) {
        // Set opacity to 1 if undefined or invalid
        if (!(opacity >= 0 && opacity <= 1)) {
            opacity = 1;
        }

        return 'rgba(' + rgb + ', ' + opacity + ')';
    },

    /**
     * Converts a color represented by a hex string to an `rgb()` string.
     * @param {string} hex The hex color to be converted.
     * @returns {string}
     */
    hexToRGB: function(hex) {
        var r, g, b,
            hexToDec = function (hex) {
                return parseInt(hex, 16);
            };
        if ('#' == hex.charAt(0)) {
            hex = hex.substring(1, 7);
        }
        if (6 == hex.length) {
            r = hex.substring(0, 2);
            g = hex.substring(2, 4);
            b = hex.substring(4, 6);
        } else if (3 == hex.length) {
            r = hex.substring(0, 1);
            g = hex.substring(1, 2);
            b = hex.substring(2, 3);
        } else {
            return '';
        }

        r = hexToDec(r);
        g = hexToDec(g);
        b = hexToDec(b);

        return 'rgb(' + [r, g, b].join(', ') + ')';
    },

    /**
     * Converts a color represented by a hex string to an `rgba()` string with the requested opacity.
     * @param {string} hex     The hex color to be converted.
     * @param {number} opacity The opacity of the color.
     * @returns {string}
     */
    hexToRGBa: function(hex, opacity) {
        var rgb = this.hexToRGB(hex).replace('rgb(', '').replace(')', '');

        // Set opacity to 1 if undefined or invalid
        if (!(opacity >= 0 && opacity <= 1)) {
            opacity = 1;
        }

        return 'rgba(' + rgb + ', ' + opacity + ')';
    },

    // Lighten or Darken a RGB color
    //
    // @param string   color     Must be HEX format with # and 6 characters.
    // @param number   percent   1.0 to -1.0
    //
    // https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
    shadeHEX: function (color, percent) {
        var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
        return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
    }
};

/**
 * Sonny Font Families
 *
 * *****************************************************************************************************************
 * Website LESS CSS font family replicated into JS variables for use with scripts like chartsjs. This should always be
 * in sync with color variables of the same name (camelCase in js instead of dashes in LESS) in variables-forked.less.
 *
 **/

var sonnyFont = {
    family: {
        sansSerif: "'Roboto',Georgia,Arial,'Liberation Sans','Nimbus Sans L','FreeSans','Helvetica Neue',Helvetica,sans-serif",
        serif: "Georgia,'DejaVu Serif','Bitstream Vera Serif','Century Schoolbook L','Lucida Bright',serif",
        monospace: "'Source Code Pro','Lucida Console',Monaco,'Liberation Mono','Nimbus Mono L','FreeMono','DejaVu Mono','Bitstream Vera Mono','Courier New',monospace",
        base: "'Roboto',Georgia,Arial,'Liberation Sans','Nimbus Sans L','FreeSans','Helvetica Neue',Helvetica,sans-serif"
    }
};

/**
 * Sonny Number Formats
 *
 * *****************************************************************************************************************
 * Because toLocaleString() method is not cross-browser.
 *
 **/

var sonnyNumFormat = {

    // Add commas every 3 to string. Must have less than 3 decimal places
    //
    // @param string    n    Number you want to format that is already a string
    //
    // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript#answer-2901298
    stringAddCommas: function(n) {
        return n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    // Add commas every 3 to number and set decimal places
    //
    // @param number    n    Number you want to format.
    // @param number    d    (Optional) Number of decimal places. If undefined default of 0 is used.
    //
    // https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-money-in-javascript?answertab=votes#answer-14428340
    // http://www.codereadability.com/javascript-default-parameters-with-or-operator/
    numberAddCommas: function(n, d) {

        if (d === undefined) {
            d = 0;
        }

        var re = '\\d(?=(\\d{' + 3 + '})+' + (d > 0 ? '\\.' : '$') + ')';
        return n.toFixed(Math.max(0, ~~d)).replace(new RegExp(re, 'g'), '$&,');
    }
};
